import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Row, Col, Button, ButtonToolbar, Input} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';

import ContentWrapper from '../../../components/Layout/ContentWrapper';
import Spinner from '../../../components/Widgets/spinner';
import SpinnerButton from '../../Common/SpinnerButton';
import CashFormatter from '../../Common/cashFormatter';

import { fetchPODetailCCW, savePODetailCCW } from '../../../actions/purchaseOrderList_actions';

const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');

const propTypes = {
  rowKey: PropTypes.string,
  poId: PropTypes.number,
  handleClosed: PropTypes.func,
  handleRefetch: PropTypes.func,
};

const defaultProps = {
  rowKey: 'Index',
  poId: undefined,
  handleClosed: () => {},
  handleRefetch: () => {},
};

class ReceivingDetailTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      poDetailLine: {
        rows: [],
        selectedRows: null,
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        gourpOpen: false,
      },
      handlingCost: 0,
      shippingCost: 0,
      tax: 0,
      isLoadingImages: false,
    };
  }

  componentDidMount() {
    this.fetchPODetail();
  }

  fetchPODetail = () => {
    const handleSuccess = (response) => {
      const rows = response.data.purchase_order_lines || [];
      rows.map((row, index) => {
        row.Index = index;
      });
      const poDetailLine = {
        ...this.state.poDetailLine,
        rows,
      };
      
      this.setState({
        handlingCost: response.data.HandlingCost,
        shippingCost: response.data.ShippingCost,
        tax: response.data.Tax,
        poDetailLine,
        isLoadingImages: false,
      });
    };
    const handleFailure = (error) => {
      alert(error);
      const poDetailLine = {
        ...this.state.poDetailLine,
        rows,
      };
      this.setState({
        poDetailLine,
        isLoadingImages: false,
      });
    };
    this.setState({
      isLoadingImages: true,
    }, () => fetchPODetailCCW(this.props.poId, handleSuccess, handleFailure));
  }
  
  handleSave() {
    const handleSuccess = () => {
      this.props.handleRefetch();
      this.setState({
        isLoadingImages: false,
      }, () => this.props.handleClosed());
    };
    
    const handleFailure = (error) => {
      alert(error);
      this.setState({
        isLoadingImages: false,
      });
    };
    
    const { handlingCost, shippingCost, tax, poDetailLine } = this.state;
    let products = [];
    poDetailLine.rows.forEach((row) => {
      products.push({
        Product_id: row.Product_id,
        Price: Number(row.unit_price),
      });
    });
    const data = {
      ShippingCost: Number(shippingCost),
      HandlingCost: Number(handlingCost),
      Tax: Number(tax),
      Products: products,
    }
    this.setState({
      isLoadingImages: true,
    }, () => savePODetailCCW(this.props.poId, data, handleSuccess, handleFailure));
  }
  
  handleCancel() {
    this.props.handleClosed();
  }

  renderTable() {
    const { poDetailLine } = this.state;
    const getRows = () => Data.Selectors.getRows(this.state.poDetailLine);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };
    
    //Custom Formatter component
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });
    const IsFixedFormatter = React.createClass({
      render() {
        if (this.props.dependentValues.ProductType === "Non-Fixed") {
          return <span style={{ 'font-weight': 'bold' }}>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
        } else {
          return <span style={{ 'font-weight': 'bold' }}>{this.props.value}</span>;
        }
      }
    });
    
    // Handle the editable function
    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      const rows = getRows();
  
      Object.assign(rows[e.rowIdx], e.updated);
      let unitPrice = e.updated.unit_price;
      
      let subtotal = rows[e.rowIdx].quantity * unitPrice;
      Object.assign(rows[e.rowIdx], {'subtotal': subtotal});

      const poDetailLine = {
        ...this.state.poDetailLine,
        rows,
      };
      this.setState({ poDetailLine });
    };
    
    const columns = [{
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }, {
        key: 'RefNum',
        name: <Translate value="ref_num" />,
        resizable: true,
        width: 100,
      }, {
        key: 'name',
        name: <Translate value="prod_name" />,
        resizable: true,
        width: 150,
      }, {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        width: 100,
      }, {
        key: 'quantity',
        name: <Translate value="qty" />,
        resizable: true,
        width: 50,
      },  {
        key: 'ReceiveQuantity',
        name: <Translate value="total_received_qty" />,
        resizable: true,
        width: 120,
      }, {
        key: 'ReceiveUnitPrice', // unit_price
        name: <Translate value="unit_price" />,
        resizable: true,
        editable: true,
        width: 70,
        formatter: CashFormatter,
      }, {
        key: 'subtotal',
        name: <Translate value="total" />,
        resizable: true,
        width: 90,
        formatter: CashFormatter,
      }, {
        key: 'ReceiveTotalWeight',
        name: <Translate value="receive_total_wt" />,
        resizable: true,
        width: 100,
        textAlign: 'right',
      },
    ];
    
    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: "100%" }} id="Category_2-dataGrid1">
            <DraggableContainer>
              <ReactDataGrid
                enableCellSelect
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                rowHeight={25}
                headerRowHeight={45}
                onRowUpdated={handleRowUpdated}
              />
            </DraggableContainer>
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    const modalStyle = {
      width: '1012px',
      height: '500px',
    };
    const { handlingCost, shippingCost, tax } = this.state;

    return (
      <ContentWrapper>
        <div id="product-images-modal">
          <div style={{ 'margin-top': '12px' }}>
            <div className="toolbar-row">
              <ButtonToolbar>
                <Button bsStyle="primary" type="button" onClick={() => { this.handleSave() }}>
                  <em className="fa fa-save" /><Translate value="save" />
                </Button>
                <Button bsStyle="danger" type="button" onClick={() => { this.handleCancel() }}>
                  <em className="fa fa-close" /><Translate value="cancel" />
                </Button>
              </ButtonToolbar>
            </div>
            <Row>
              <Col xs={4}>
                <label style={{ display: 'inline-flex', 'margin-top': '12px', 'margin-left': '10px' }}>
                  <Translate value="handling_cost" /><span className="dollar-sign"></span>:&nbsp;
                  <Input
                    type="text"
                    value={handlingCost}
                    onChange={({ target }) => this.setState({
                      handlingCost: target.value
                    })}
                  />
                </label>
              </Col>
              <Col xs={4}>
                <label style={{ display: 'inline-flex', 'margin-top': '12px', 'margin-left': '10px' }}>
                  <Translate value="shipping_cost" /><span className="dollar-sign"></span>:&nbsp;
                  <Input
                    type="text"
                    value={shippingCost}
                    onChange={({ target }) => this.setState({
                      shippingCost: target.value
                    })}
                  />
                </label>
              </Col>
              <Col xs={4}>
                <label style={{ display: 'inline-flex', 'margin-top': '12px', 'margin-left': '10px' }}>
                  <Translate value="tax" /><span className="dollar-sign"></span>:&nbsp;
                  <Input
                    type="text"
                    value={tax}
                    onChange={({ target }) => this.setState({
                      tax: target.value
                    })}
                  />
                </label>
              </Col>
            </Row>
            {this.renderTable()}
          </div>
        </div>
      </ContentWrapper>
    );
  }
}

ReceivingDetailTable.propTypes = propTypes;
ReceivingDetailTable.defaultProps = defaultProps;

export default ReceivingDetailTable;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/components/ReceivingDetailTable.jsx